import { useQuery } from '@tanstack/react-query';

export function useProjectsAnalyticsSignatureStatusReportQuery({
  params = {},
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projectsAnalytics', 'signatureStatusReports', params],
    queryFn: async () => {
      const response = await axios.post(
        '/projects_analytics/signature_status_reports',
        { signature_status_report: params },
      );

      return response.data;
    },
    ...queryOptions,
  });
}
